import { render, staticRenderFns } from "./K8sNodePanel.vue?vue&type=template&id=ffd584aa&"
import script from "./K8sNodePanel.vue?vue&type=script&lang=js&"
export * from "./K8sNodePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports